import { isNationalLengthOverMax } from '@/utils/phoneIntl';

/**
 * +44 / +353: strip non-digits on input and show an inline hint when national part exceeds max length.
 */
export default {
  methods: {
    onInputPhoneDigitsOnly(e, formObj, phoneKey = 'phone') {
      const f = formObj;
      if (!e || !f) return;
      const digits = String(e.target.value || '').replace(/\D/g, '');
      this.$set(f, phoneKey, digits);
    },
    getPhoneNationalOverMaxHint(formObj, phoneKey = 'phone', codeKey = 'code') {
      if (!formObj) return '';
      const code = formObj[codeKey];
      const raw = formObj[phoneKey];
      if (!code || raw === undefined || raw === null || raw === '') return '';
      if (!isNationalLengthOverMax(code, raw)) return '';
      if (code === '+44') {
        return 'UK: maximum 12 digits in this box (excluding +44). Please remove extra digits.';
      }
      if (code === '+353') {
        return 'Ireland: maximum 11 digits in this box (excluding +353). Please remove extra digits.';
      }
      return '';
    },
  },
};
